import React from 'react';
import { Table, TableProps } from '@otp/ui';
import { useTranslation } from 'react-i18next';

import {
  WttpQuestionnaire,
  WttpSchedulesDocument,
  WttpSchedulesQuery,
  WttpTemplate,
} from 'src/graphql/generated/graphql';
import {
  getTableConfig,
  OnScheduleChangeType,
  QuestionnairesSchedule,
} from './config';
import { useQuery } from '@apollo/client';

export type { QuestionnairesSchedule } from './config';

export type WttpQuestionnairesTableProps = Omit<TableProps, 'columns'> & {
  className?: string;
  data: Pick<WttpQuestionnaire, 'id' | 'name' | 'organizationId'>[];
  onScheduleChange: OnScheduleChangeType;
  value?: QuestionnairesSchedule[];
};

export const WttpQuestionnairesTable = ({
  className,
  data,
  options,
  onScheduleChange,
  value,
  ...props
}: WttpQuestionnairesTableProps) => {
  const { t } = useTranslation();

  const { data: scheduleData } = useQuery<WttpSchedulesQuery>(
    WttpSchedulesDocument,
    {
      variables: {
        pagination: {
          limit: 100,
          offset: 0,
        },
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-only',
    },
  );
  const schedules = scheduleData?.wttpSchedules?.records || [];

  const tableConfig = getTableConfig((data || []) as WttpTemplate[], {
    t,
    onScheduleChange,
    schedules,
    selectedQuestionnaireIds: props.selectedRowIds || [],
    value,
  });

  return (
    <div className={className}>
      <Table options={options} {...props} data={data} columns={tableConfig} />
    </div>
  );
};
